import * as regexes from "./../../../../shared/src/regexes";

export const isValidEmail = (text) => (new RegExp(regexes.constants.EMAIL_REGEX)).test(text);